module.exports = __webpack_public_path__ + "static/media/Brandon_med.4578b811.woff";